export default __webpack_public_path__ + "afdbc2bf279d979a56859993b4319582.gif";